// import './smslogdetails.css';
import Skeleton from '@mui/material/Skeleton';

const Loading = ({data, loading}) => {
    if (loading) {
        return <div className="px-2" style={{float: 'left'}}><Skeleton variant="rectangular" height={20} width={50} /></div>;
    } else {
        return <div className="px-2" style={{float: 'left'}}>{data}</div>;
    }
}

const NestedObjectDisplay = ({ data, level = 0 }) => {
    if (data === null || data === undefined) return null;
    
    return (
        <div style={{ marginLeft: `${level * 20}px` }}>
            {Object.entries(data).map(([key, value]) => (
                <div key={key}>
                    <strong>{key}:</strong>{' '}
                    {typeof value === 'object' && value !== null ? (
                        <NestedObjectDisplay data={value} level={level + 1} />
                    ) : (
                        <span>{String(value)}</span>
                    )}
                </div>
            ))}
        </div>
    );
};

const CallLogDetails = ({data,  loading}) => {
    console.log("Details", data);
    const callLogData = data;
    if (callLogData == undefined) {
        return <div>No data</div>;
    }
    let status = ''
    if (loading) {
        status = '';
    } else {
        status = 'status-ok';
    }
    
    return (
        <div className="cdrcard shadow-sm">
            <table className="table table-bordered">
                <tbody>
                    <tr>
                        <td>Call ID</td>
                        <td>{data.call_id}</td>
                    </tr>
                    <tr>
                        <td>Contact</td>
                        <td>{data.contact?.first_name} {data.contact?.last_name}</td>
                    </tr>
                    <tr>
                        <td>Task</td>
                        <td>{data.task_version?.name}</td>
                    </tr>
                    <tr>
                        <td>Status</td>
                        <td>{data.status}</td>
                    </tr>
                     <tr>
                        <td>Instructions</td>
                        <td>{data.task_version?.instructions?.length > 100 ? data.task_version.instructions.substring(0, 100) + '...' : data.task_version?.instructions}</td>
                    </tr>
                    <tr>
                        <td>Created At</td>
                        <td>{new Date(data.created_at).toUTCString()}</td>
                    </tr>
                    <tr>
                        <td>Updated At</td>
                        <td>{new Date(data.updated_at).toUTCString()}</td>
                    </tr>
                </tbody>
            </table>
            <table className="table table-bordered">
                <tbody>
                {data.callDetails.map((callDetail) => (
                    <tr key={callDetail.id}>
                        <td>{callDetail.event_time}</td>
                        <td>{callDetail.event_type}</td>
                        <td>
                            {callDetail.event_data != null && (
                                <NestedObjectDisplay data={callDetail.event_data} />
                            )}
                        </td>
                    </tr>
                ))}
                </tbody>
            </table>
        </div>
    )
}

export default CallLogDetails;